import { useState } from "react";
import { toast } from "sonner";
import { Geo } from "../lib/api";

export function AddressSearch({ onPick }) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState([]);
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    if (q.trim().length < 2) return;
    setBusy(true);
    try {
      const r = await Geo.geocode(q.trim());
      setHits(r.results);
      if (r.unavailable) toast.error("Address lookup is busy right now. Try again in a moment, or tap the map.");
      else if (!r.results.length) toast.message("No place found for that address");
      if (r.results.length === 1) { onPick(r.results[0]); setHits([]); }
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Address lookup failed");
    } finally { setBusy(false); }
  };
  return (
    <div className="relative">
      <form onSubmit={go} className="flex gap-2">
        <input value={q} onChange={(e) => setQ(e.target.value)} maxLength={200} placeholder="Address or place"
          className="border-2 border-black px-3 py-2 font-mono text-sm flex-1 min-w-0" data-testid="locate-address-input" />
        <button type="submit" disabled={busy} className="btn-flat-outline" data-testid="locate-address-btn">{busy ? "…" : "Find"}</button>
      </form>
      {hits.length > 1 && (
        <ul className="absolute z-[1100] left-0 right-0 mt-1 border-2 border-black bg-slate-950 divide-y divide-white/10" data-testid="locate-address-results">
          {hits.map((h, i) => (
            <li key={i}>
              <button onClick={() => { onPick(h); setHits([]); }} className="w-full text-left px-3 py-2 text-xs hover:bg-white/5" data-testid={`locate-address-hit-${i}`}>{h.label}</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
